import { Scenarios } from '@jfs/network'

const checkWhetherTheCustomerExists = {
  default: [
    {
      url: /user\/validate/,
      method: 'GET',
      response: {
        status: 'SUCCESS',
        data: {
          remittanceUserId: '1703531602893484339',
          aadharToken: 'remitter aadhar token', // if this field is empty or null do ekyc else ekyc is done.
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /user\/validate/,
      method: 'GET',
      responseCode: 500,
      response: { status: 'FAILURE', error: { code: '30013', message: 'User does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { checkWhetherTheCustomerExists }
